import React, { useState } from 'react';
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  Space,
  Switch,
} from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import { createAgroLider } from 'modules/agroLiderModule/requests/agroLiderRequests';
import FormFileUpload from 'modules/galleryModules/components/FormFileUpload';
import { FieldData } from 'rc-field-form/lib/interface';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';

const AgroLiderAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [file1, setFile1] = useState<string | null>(null);
  const [fields, setFields] = useState<FieldData[]>([]);
  const [form] = Form.useForm();
  const [fileImage1, setFileImage1] = useState<string | null>(null);

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createAgroLider(values).then(() => {
      toggleButtonLoading(false);
      form.resetFields();
      setFile1(null);
      setFileImage1(null);
    });
  };

  const updateFile = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/agro-lider">AGROlider</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/agro-lider/add">+</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            fields={fields}
            form={form}
          >
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>

            <Form.Item
              name="fileImage1"
              label="Okładka"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormCoverUpload
                cover={fileImage1}
                setCover={(e) => updateCover(e, 'fileImage1', setFileImage1)}
                isNew
                field="fileImage1"
                number={1}
                hideTags
                dontResize
              />
            </Form.Item>

            <Form.Item
              name="dateAdd"
              label="Data dodania"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {/*// @ts-ignore*/}
              <DatePicker showTime />
            </Form.Item>

            <Form.Item
              name="title"
              label="Nazwa"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="fileName1"
              label="Plik do pobrania PDF"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormFileUpload
                file={file1}
                setFile={(e) => updateFile(e, 'fileName1', setFile1)}
                isNew
                field="fileName1"
              />
            </Form.Item>

            <Form.Item
              name="isActive"
              label="Widoczność"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default AgroLiderAdd;
